export class AnalyticsDTO {
  ym!: string;
  increaseStudent = 0; //生徒増加数
  increaseTeacher = 0; //先生増加数
  res_count = 0; //レッスン数（予約依頼中）
  com_count = 0; //レッスン数（予約確定）
  done_count = 0; //レッスン数（実施）
  del_count = 0; //レッスン数（キャンセル）
  tra_count = 0; //レッスン数（振替）
  application_count = 0; //先生の申込数
}
